import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RgbaColor } from "react-colorful";
import { SphereDto } from "./SphereTracker";

export interface SphereSettingsDto {
    nbSometimes: number,
    keysanity: boolean,
    alwaysHints: "scrubs" | "s7" | "multiworld",
    cowsanity: boolean,
    scrubsanity: boolean
}
export interface OotrSphereState {
    spheres: Array<SphereDto>,
    player1: string,
    player1Color: RgbaColor | undefined,
    player2: string,
    player2Color: RgbaColor | undefined
    settings: SphereSettingsDto
}

export const initialOotrState: OotrSphereState = {
    spheres: [{ id: 0, items: [null] }],
    player1: "",
    player1Color: undefined,
    player2: "",
    player2Color: undefined,
    settings: {
        nbSometimes: 7,
        keysanity: false,
        alwaysHints: "s7",
        cowsanity: false,
        scrubsanity: false
    }
}

export const ootrSphereSlice = createSlice({
    name: 'ootr sphere tracker reducer',
    initialState: initialOotrState,
    reducers: {
        setSpheres(state: OotrSphereState, action: PayloadAction<Array<SphereDto>>) {
            state.spheres = action.payload
        },
        addSphere(state: OotrSphereState) {
            state.spheres = [...state.spheres, { id: state.spheres.length, items: [null] }]
        },
        removeSphere(state: OotrSphereState, action: PayloadAction<number>) {
            //remove sphere and transfer item
            let copySpheres: Array<SphereDto> = JSON.parse(JSON.stringify(state.spheres))
            let newSpheres: Array<SphereDto> = []
            copySpheres.forEach(x => { if (x.id !== action.payload) newSpheres.push(x); })
            let spheres = [...copySpheres.slice(0, action.payload), ...copySpheres.slice(action.payload + 1)];

            spheres.forEach((x, i) => {


                if (x.id !== i) {
                    x.items = copySpheres[x.id].items
                }
                x.id = i;

            });

            state.spheres = spheres;
        },
        setSphereItems(state: OotrSphereState, action: PayloadAction<SphereDto>) {
            state.spheres[action.payload.id] = action.payload;
        },
        setPlayer1Name(state: OotrSphereState, action: PayloadAction<string>) {
            state.player1 = action.payload;
        },
        setPlayer2Name(state: OotrSphereState, action: PayloadAction<string>) {
            state.player2 = action.payload;
        },
        setPlayer1Color(state: OotrSphereState, action: PayloadAction<RgbaColor | undefined>) {
            state.player1Color = action.payload;
        },
        setPlayer2Color(state: OotrSphereState, action: PayloadAction<RgbaColor | undefined>) {
            state.player2Color = action.payload;
        }


    }

});

export const {
    setSpheres,
    addSphere,
    removeSphere,
    setSphereItems,
    setPlayer1Name,
    setPlayer2Name,
    setPlayer1Color,
    setPlayer2Color
} = ootrSphereSlice.actions

export const ootrSphereReducer = ootrSphereSlice.reducer